import React, { useEffect, useState } from "react";
import AdminLTE, {
  Sidebar,
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  Label,
  SimpleTable,
  Pagination,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import { thousandSeparator } from "../utils/utils";

const { Select2, Date, DateTime, Text } = Inputs;

function SucursalesList({ history, match }) {
  const dispatch = useDispatch();

  const modelLocales = useSelector((state) => state.getLocales);

  const [locales, setLocales] = useState(null);
  const [totalResults, setTotalResults] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    const data = modelLocales?.data?.data;
    const error = modelLocales?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckGetLocales.actions.clear());
    }
    if (data) {
      setLocales(data.data.items);
      setTotalResults(data.data.total);

      dispatch(controller.duckGetLocales.actions.clear());
    }
  }, [modelLocales]);

  useEffect(() => {
    if (
      localStorage.getItem("localSelected") &&
      localStorage.getItem("categoriaSelected")
    ) {
      localStorage.removeItem("localSelected");
      localStorage.removeItem("categoriaSelected");
      return window.location.reload();
    }
    dispatch(controller.getLocalesThunk(1, pageSize, match.params.localId));
  }, []);

  function handlePage(page) {
    setActivePage(page);
    setLocales([]);
    dispatch(
      controller.getLocalesThunk(page + 1, pageSize, match.params.localId)
    );
  }

  return (
    <Content
      title="Locales"
      subTitle="Locales"
      browserTitle="Locales"
      show={false}
    >
      <Row>
        <Col md="10" mdOffset="1">
          <Box title="Sucursales">
            <Button
              type="primary"
              text="Agregar"
              pullRight={true}
              onClick={() =>
                history.push(
                  `/nuevoLocal/${match.params.localId}/${match.params.categoriaId}`
                )
              }
            />
            <div>
              <span>Total: {totalResults}</span>
            </div>
            {locales && locales.length > 0 ? (
              <SimpleTable
                hover={true}
                data={locales.map((row, index) => {
                  return {
                    nombre: row.nombre,
                    estado: row.estado,
                    categoria: row.categoriaNombre,
                    detalles: (
                      <Button
                        type="primary"
                        text="Detalles"
                        size="sm"
                        onClick={() => {
                          localStorage.setItem("localSelected", row._id);
                          localStorage.setItem(
                            "categoriaSelected",
                            row.categoria
                          );

                          window.location.href = "/calendarioLocal/"+row._id;
                        }}
                      />
                    ),
                  };
                })}
                columns={[
                  { title: "Nombre", data: "nombre" },
                  { title: "Categoria", data: "categoria" },
                  { title: "Estado", data: "estado" },
                  { title: "Detalles", data: "detalles" },
                ]}
              />
            ) : (
              <h4>No se han encontrado sucursales</h4>
            )}
            <Pagination
              activePage={activePage}
              pageSize={pageSize}
              totalElements={totalResults}
              onChange={handlePage}
              labels={{
                first: "Primera",
                last: "Última",
                previous: "Anterior",
                next: "Siguiente",
              }}
            />
            <div>
              <span>Total: {totalResults}</span>
            </div>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default SucursalesList;
